import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/satina-platform-frontends/satina-platform-frontends/apps/iv-website/app/expert-detail/[expertIdentifier]/ExpertDetail.tsx");
